import { c as _c } from "react/compiler-runtime";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import { useMemo } from "react";
import { useI18n } from "@llmgateway/i18n/react";
import { useAppConfig } from "./config";
import type { paths } from "./api/v1";
export function useFetchClient() {
  const $ = _c(3);
  const config = useAppConfig();
  const {
    locale
  } = useI18n();
  let t0;
  if ($[0] !== config.apiUrl || $[1] !== locale) {
    t0 = createFetchClient({
      baseUrl: config.apiUrl,
      credentials: "include",
      headers: {
        "x-locale": locale
      }
    });
    $[0] = config.apiUrl;
    $[1] = locale;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function useApi() {
  const $ = _c(2);
  const fetchClient = useFetchClient();
  let t0;
  if ($[0] !== fetchClient) {
    t0 = createClient(fetchClient);
    $[0] = fetchClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}